import { render } from "./RecordingsCatalog.vue?vue&type=template&id=4df00712&ts=true&lang=pug"
import script from "./RecordingsCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordingsCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__